import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import type { Point as HighchartsPoint } from "highcharts";
import dayjs from "dayjs";
import numeral from "numeral";
import { renderToString } from "react-dom/server";
import styled from "styled-components";

import { fullMonthAndYear, fullMonthDayAndYear } from "@similarweb/pro-logic-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { BenchmarkGranularity } from "../../../services/api/constants";
import type { BenchmarkUrlParams } from "../../../types/paramsTypes";

// Quick fix for styled components issue with updated highcharts
const Text = styled.div`
    ${setFontVariant("body2")};
`;

export const useTrendCellConfig = () => {
    const {
        params: { granularity },
    } = useCurrentStateAndParams<BenchmarkUrlParams>();

    return useMemo(
        () => ({
            tooltip: {
                enabled: true,
                outside: true,
                useHTML: true,
                hideDelay: 0,
                // TODO: Update AreaLightGraphCell component to include tooltip
                formatter(this: HighchartsPoint) {
                    const format =
                        granularity === BenchmarkGranularity.MONTHLY ? fullMonthAndYear : fullMonthDayAndYear;
                    const date = dayjs.unix(this.x).format(format);

                    return renderToString(
                        <div
                            style={{
                                display: "flex",
                                gap: "32px",
                                borderRadius: "3px",
                                alignItems: "center",
                                background: colorsPalettes.carbon[0],
                            }}
                        >
                            <Text>{date}</Text>
                            <Text>{numeral(this.y).format("0.00%")}</Text>
                        </div>,
                    );
                },
            },
        }),
        [granularity],
    );
};
